import type { FieldConfig } from '@/components/form/SchemaForm/types';
import type { TFunction } from 'i18next';

type InviteContactFieldsOptions = {
  t: TFunction;
  /** Include `name` field (AddCompanyRecruiterForm). Default: email only. */
  includeName?: boolean;
  emailHelp?: string;
  emailPlaceholder?: string;
  /** Override for `name` label (defaults to full name). */
  nameLabel?: string;
  namePlaceholder?: string;
};

export function buildInviteContactFieldConfigs(
  options: InviteContactFieldsOptions,
): FieldConfig[] {
  const {
    t,
    includeName,
    emailHelp,
    emailPlaceholder,
    nameLabel,
    namePlaceholder,
  } = options;

  const fields: FieldConfig[] = [
    {
      name: 'email',
      type: 'text',
      colSpan: includeName ? 12 : 24,
      label: t('EMAIL'),
      help: emailHelp,
      componentProps: emailPlaceholder
        ? { placeholder: emailPlaceholder }
        : undefined,
    },
  ];

  if (includeName) {
    fields.push({
      name: 'name',
      type: 'text',
      colSpan: 12,
      label: nameLabel ?? t('FULL_NAME'),
      componentProps: namePlaceholder
        ? { placeholder: namePlaceholder }
        : undefined,
    });
  }

  return fields;
}
